export default {
	TEAM: 'team',
};



// WEBPACK FOOTER //
// ./src/utils/variants.js